<div class="RightPanel" id="rightPanel" [hidden]="activeWidget || showEmptyHashtags">
  <div class="infobar">
    <report-designer-page-navigation [main]="main" [infobar]="this"></report-designer-page-navigation>
  </div>
</div>

<div class="report-designer-infobar RightPanel infobarBright" id="rightPanel" *ngIf="activeWidget && !showEmptyHashtags">
  <div *ngIf="activeWidget" class="wrapper">
    <kendo-tabstrip style="width: 100%; height: 100%;">

      <kendo-tabstrip-tab [selected]="selectedTabIndex === 0">
        <ng-template kendoTabTitle>
          <span class="k-icon k-i-gear"></span>
        </ng-template>
        <ng-template kendoTabContent>
          <div style="height: 100%; margin:0; overflow-x: hidden;">
            <div class="dialogContainer infobarBright">
              <div class="dialogContainerLeft">

                    <div *ngIf="activeWidget.widgetConfig.widgetLockInfo.locked && !activeWidget.widgetConfig.widgetLockInfo.lockedByCurrentUser" class="widget-lockinfo-message widget-lockedotherinfo-message">
                      {{ 'widgetLock.checkedOutByUser' | translate }} {{activeWidget.widgetConfig.widgetLockInfo.lockedByUserName}} {{ 'widgetLock.atTime' | translate }} {{activeWidget.widgetConfig.widgetLockInfo.lockedAt | date:'HH:mm, dd/MM/yyyy'}}
                    </div>

                    <div *ngIf="activeWidget.widgetConfig.widgetLockInfo.locked && activeWidget.widgetConfig.widgetLockInfo.lockedByCurrentUser" class="widget-lockinfo-message widgetLockedByCurrentUser">
                       {{ 'widgetLock.checkedOutByCurrentUser' | translate }} {{ 'widgetLock.atTime' | translate }} {{activeWidget.widgetConfig.widgetLockInfo.lockedAt | date:'HH:mm, dd/MM/yyyy'}}
                    </div>

                    <div *ngIf="activeWidget.widgetConfig.widgetModifiedInfo" class="widget-updateinfo-message">
                        {{ 'widgetLock.modifiedByUser' | translate }} {{activeWidget.widgetConfig.widgetModifiedInfo.modifiedByUserName}} {{ 'widgetLock.atTime' | translate }} {{activeWidget.widgetConfig.widgetModifiedInfo.modifiedAt | date:'HH:mm, dd/MM/yyyy'}}
                    </div>

                    <div *ngIf="activeWidget.widgetConfig.widgetSettings.availableLayouts && activeWidget.widgetConfig.widgetSettings.availableLayouts.length">
                      <div class="dialogLabel uppercase">{{ 'widgetLayout' | translate }}</div>
                      <kendo-dropdownlist [(ngModel)]="currentLayout"
                                          [data]="layoutsDataSource"
                                          (ngModelChange)="layoutChanged()">
                      </kendo-dropdownlist>
                    </div>

                    <div *ngIf="activeWidget.availableCalculations.length > 0">
                      <div *ngIf="!activeWidget.widgetConfig.widgetSettings.hideCalculationLabel" class="dialogLabel">{{ 'calculationMethod' | translate }}</div>
                      <kendo-dropdownlist [(ngModel)]="currentCalculation"
                                          [data]="calculationDataSource"
                                          textField="description"
                                          valueField="id"
                                          (ngModelChange)="calculationChanged()"
                                          [valuePrimitive]="true">
                      </kendo-dropdownlist>
                    </div>

                    <div *ngIf="activeWidget.widgetConfig.widgetSettings.showButtonGetPixCompsData">
                        <button class="k-button" (click)="getPixCompsData()">{{'getPixCompsData' | translate}}</button>
                    </div>

                    <div *ngIf="activeWidget.widgetConfig.widgetSettings.buttonCostsOfSale && activeWidget.widgetConfig.widgetSettings.currentLayout === 'DCF'">
                      <button class="k-button" (click)="activeWidget.toggleButtonCostsOfSale(!activeWidget.widgetConfig.widgetSettings.buttonCostsOfSale.show)">{{ (activeWidget.widgetConfig.widgetSettings.buttonCostsOfSale.show ? 'showCostsOfSale' : 'hideCostsOfSale') | translate}}</button>
                    </div>

                    <div *ngIf="activeWidget.toggleHideGrossCapitalValueRounded">
                      <button class="k-button" (click)="activeWidget.toggleHideGrossCapitalValueRounded()">
                        {{ (activeWidget.widgetConfig.widgetSettings.customSettings.hideGrossCapitalValueRounded ? 'showGrossCapitalValueRounded' : 'hideGrossCapitalValueRounded') | translate}}
                      </button>
                    </div>

                    <div *ngIf="activeWidget.toggleHidePurchasersCosts">
                      <button class="k-button" (click)="activeWidget.toggleHidePurchasersCosts()">
                        {{ (activeWidget.widgetConfig.widgetSettings.customSettings.hidePurchasersCosts ? 'showPurchasersCosts' : 'hidePurchasersCosts') | translate}}
                      </button>
                    </div>

                    <div>
                      <div class="dialogLabel uppercase">{{ 'comment' | translate }}</div>
                      <widget-infobar-comment [widgetConfig]="activeWidget.widgetConfig"></widget-infobar-comment>
                    </div>


              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab *ngIf="activeWidget" [selected]="selectedTabIndex === 1">
        <ng-template kendoTabTitle>
          <span class="k-icon k-i-module-manager"></span>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="hashtagsContainer">
            <hashtags-per-widget [widgetId]="activeWidget.widgetConfig.widgetId"></hashtags-per-widget>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>

  </div>
</div>

<div class="RightPanel infobarBright" id="rightPanel" *ngIf="showEmptyHashtags">
  <hashtags-overview></hashtags-overview>
</div>
